import { render, staticRenderFns } from "./LavagemAutomatizada.vue?vue&type=template&id=055fd993&"
import script from "./LavagemAutomatizada.vue?vue&type=script&lang=js&"
export * from "./LavagemAutomatizada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports